export default __webpack_public_path__ + "static/media/mo-brand.f68ad536.gif";